import { ReactComponent as MiniscreenOfflineIcon } from '@lmt/unicorn-shared/app/icons/ms-offline.svg';
import { ReactComponent as MiniscreenOnlineIcon } from '@lmt/unicorn-shared/app/icons/ms-online.svg';
import clsx from 'clsx';
import React, { FC } from 'react';
import styles from './MiniscreenModeIcon.module.scss';

interface Props {
  type: 'online' | 'offline';
  className?: string;
}
export const MiniscreenModeIcon: FC<Props> = (props) => {
  return props.type === 'online' ? (
    <MiniscreenOnlineIcon
      className={clsx(styles.onlineIcon, props.className)}
    />
  ) : (
    <MiniscreenOfflineIcon
      className={clsx(styles.offlineIcon, props.className)}
    />
  );
};
